import "../css/BirthChart.css";
import { useState, useEffect } from "react";
import axios from "axios";
import ApiConfig from "../utils/ApiConfig";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const BirthChart = () => {

  var location = useLocation();
  var { profile } = location.state || {};
  const navigation = useNavigate();

  // =========================================================
  // STATES
  // =========================================================

  const [dateOfBirth, setDateOfBirth] = useState("");
  const [birthTime, setBirthTime] = useState("");
  const [birthPlace, setBirthPlace] = useState("");
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const savedDOB = localStorage.getItem("user_dob");
    const savedTime = localStorage.getItem("user_time_of_birth");
    const savedPlace = localStorage.getItem("user_place_of_birth");

    console.log("Saved DOB:", savedDOB);
    console.log("Saved Time:", savedTime);
    console.log("Saved Place:", savedPlace);

    // =========================
    // DOB
    // =========================

    if (savedDOB) {

      const dob = savedDOB.trim();

      if (dob.includes("/")) {

        const parts = dob.split("/");

        if (parts.length === 3) {

          const month = parts[0];
          const day = parts[1];
          const year = parts[2];

          const formattedDOB =
            `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

          setDateOfBirth(formattedDOB);
        }

      } else if (dob.includes("-")) {

        setDateOfBirth(dob);
      }
    }


    if (savedTime) {
      setBirthTime(savedTime.substring(0, 5));
    }

    if (savedPlace) {
      setBirthPlace(savedPlace);
    }


  }, []);

  useEffect(() => {

    if (dateOfBirth && birthTime && birthPlace) {

      console.log("All birth details ready");
      console.log("DOB:", dateOfBirth);
      console.log("TIME:", birthTime);
      console.log("PLACE:", birthPlace);

      GenerateChart();
    }

  }, [dateOfBirth, birthTime, birthPlace]);

  const rasiList = [
    { id: 11, name: "Meena" },
    { id: 0, name: "Mesha" },
    { id: 1, name: "Vrishabha" },
    { id: 2, name: "Mithuna" },
    { id: 10, name: "Kumbha" },
    { id: "center", name: "CENTER" },
    { id: 3, name: "Karkataka" },
    { id: 9, name: "Makara" },
    { id: 4, name: "Simha" },
    { id: 5, name: "Kanya" },
    { id: 6, name: "Tula" },
    { id: 7, name: "Vrischika" },
    { id: 8, name: "Dhanu" }
  ];

  // =========================================================
  // GENERATE BIRTH CHART
  // =========================================================

  const GenerateChart = async () => {

    // Validation
    if (!dateOfBirth) {
      toast.error("Please select Date of Birth");
      return;
    }

    if (!birthTime) {
      toast.error("Please select Birth Time");
      return;
    }

    if (!birthPlace.trim()) {
      toast.error("Please enter Birth Place");
      return;
    }

    try {
      setLoading(true);

      const loginData = localStorage.getItem("loginVal");

      if (!loginData) {
        toast.error("User details not found");
        return;
      }

      const loginVal = JSON.parse(loginData);
      const userId = loginVal?.user_Id;

      if (!userId) {
        toast.error("User ID not found");
        return;
      }

      // API CALL
      const response = await axios.post(
        ApiConfig.getUrl("api/Astrology/generateBirthChart"),
        null,
        {
          params: {
            userId: userId,
           
          }
        }
      );

      console.log("Birth Chart Response:", response.data);

      if (response.data?.status === true && response.data?.statusCode === 200) {
        const result = response.data?.response;

        if (!result) {
          toast.error("Birth chart response is empty");
          return;
        }

        setChartData(result);
        toast.success(response.data?.message || "Birth chart generated successfully.");

      } else {
        toast.error(response.data?.message || "Unable to generate birth chart.");
      }

    } catch (error) {
      console.error("Birth Chart Error:", error);
      const message = error?.response?.data?.message || error?.message || "Something went wrong.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };


  const getPlanetsForRasi = (rasiId) => {
    if (!chartData) return [];

    const planetList = chartData?.planet_Position?.data?.planet_position || [];

    if (!Array.isArray(planetList)) return [];

    return planetList.filter(
      (planet) => Number(planet?.rasi?.id) === Number(rasiId)
    );
  };


  const clicktocustomerdetails = () => {
    navigation("/Viewpage");
  };


  // function clicktoReligion_details() {
  //   navigate('/Religion_details')
  // }

  return (
    <div className="fullview w-100 center d-flex flex-row">
      <div className="container w-100 h-100 border text-center">

        {/* HEADER */}
        <div className="birth-chart-header d-flex mt-2" style={{ justifyContent: "space-between" }}>
          <h2>Birth Chart</h2>
          <button className="Edit-btn" onClick={clicktocustomerdetails}>
            Close
          </button>
        </div>

        <span className="subtitle-badge">ஜாதகக் கட்டம்</span>

        {/* BIRTH DETAILS */}
        <div className="birth-details-card">
          <h4 className="card-title">🗓️ Birth Details</h4>

          <div className="row g-3">

            {/* DATE */}
            <div className="col-md-4">
              <label className="form-label">Date of Birth</label>
              <input type="date"
                id="dateOfBirth"
                className="input_box"
                value={dateOfBirth}
                disabled


              />
            </div>

            {/* TIME */}
            {/* TIME */}
            <div className="col-md-4">
              <label className="form-label">Birth Time</label>

              <input
                type="time"
                className="form-control custom-input"
                value={birthTime}
                disabled
              />

              {!birthTime && (
                <span
                  className="text-danger d-block mt-1"
                  style={{ cursor: "pointer",textDecoration:"none" }}
                  onClick={() => navigation("/Editprofile")}
                >
                  Update your Time of Birth
                </span>
              )}
            </div>

            {/* PLACE */}
            <div className="col-md-4">
              <label className="form-label">Birth Place</label>

              <input
                type="text"
                className="form-control custom-input"
                placeholder="Eg: Chennai"
                value={birthPlace}
                disabled
              />

              {!birthPlace && (
                <span
                  className="text-danger d-block mt-1"
                   style={{ cursor: "pointer",textDecoration:"none" }}
                  onClick={() => navigation("/Editprofile")}
                >
                  Update your Place of Birth
                </span>
              )}
            </div>

          </div>

          {/* GENERATE BUTTON */}
          {/* <div className="text-center mt-4">
            <button
              type="button"
              className="btn btn-generate-chart w-50 p-0"
              style={{ backgroundColor: "darkorange", color: "white" }}
              onClick={GenerateChart}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate Birth Chart"}
            </button>
          </div> */}

        </div>

        <hr className="divider-line mt-5" />

        {/* RESULT */}
        {chartData && (
          <div className="birth-result-card mt-4">

            <h4 className="card-title text-center mb-4">✨ Horoscope Details</h4>

            {/* RAASI / STAR / LAGNA */}
            <div className="birth-info">
              <div>
                <strong>Raasi :</strong> {chartData?.raasi_Local || "-"}
              </div>
              <div>
                <strong>Star :</strong> {chartData?.star_Local || "-"}
              </div>
              <div>
                <strong>Laknam :</strong> {chartData?.lagna_Local || "-"}
              </div>
            </div>

            {/* RASI CHART */}
            <div className="text-center mt-5">
              <h5 className="mb-3">ராசி கட்டம்</h5>

              <div className="south-chart-grid">
                {rasiList.map((rasi, index) => {

                  if (rasi.id === "center") {
                    return (
                      <div key={index} className="chart-center-box">
                        <div className="center-title">Raasi</div>
                      </div>
                    );
                  }

                  const planets = getPlanetsForRasi(rasi.id);

                  const localRasiName =
                    planets.length > 0
                      ? (
                        planets[0]?.rasi?.name_local ||
                        planets[0]?.rasi?.name ||
                        rasi.name
                      )
                      : rasi.name;

                  return (
                    <div key={index} className="chart-box">
                      <div className="rasi-name local-language-text">
                        {localRasiName}
                      </div>

                      <div className="planets-content">
                        {planets.map((planet, pIndex) => {
                          const planetLocalName =
                            planet?.name_local ||
                            planet?.name ||
                            "-";

                          return (
                            <div key={pIndex} className="planet-badge local-language-text">
                              {planetLocalName}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* PLANET POSITION TABLE */}
            <div className="mt-5">
              <h5 className="mb-3">Planet Positions</h5>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Planet</th>
                      <th>Rasi</th>
                      <th>Degree</th>
                      <th>Retrograde</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(chartData?.planet_Position?.data?.planet_position || []).map((planet, index) => (
                      <tr key={index}>
                        <td>{planet?.name}</td>
                        <td>{planet?.rasi?.name}</td>
                        <td>{Number(planet?.degree || 0).toFixed(2)}</td>
                        <td>{planet?.is_retrograde ? "Yes" : "No"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        )}

      </div>
    </div>
  );
};

export default BirthChart;